import { theme } from 'utils/theme.v2';

export const getPaddingValues = (desktopValue) => {
  const index = theme.space.indexOf(desktopValue);

  return [index - 1, null, null, index];
};
